import { Helpers } from '../../helpers';
import { IItemRateTableName } from '../../interfaces/iitem-rate-table-name';
import { Employee } from '../employee';
import { ItemRate } from '../item-rate';
import { ProjectTemplateRateTable } from '../project-template-rate-table';

export class ItemRateTableNameBase {
  ItemRateTableNameId: number;
  TableName: string;
  OwnerId: number;
  LastUpdateUser: string;
  LastUpdatedDate: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemRates_ItemRateTableName?: Array<ItemRate> | null;
  ProjectTemplateRateTables_ItemRateTableName?: Array<ProjectTemplateRateTable> | null;
  Employee?: Employee;

  constructor(item?: IItemRateTableName) {
    if (item) {

      this.ItemRateTableNameId = item.ItemRateTableNameId;
      this.TableName = item.TableName;
      this.OwnerId = item.OwnerId;
      this.LastUpdateUser = item.LastUpdateUser;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemRates_ItemRateTableName = Helpers.createClassArray(ItemRate, item.ItemRates_ItemRateTableName);
      this.ProjectTemplateRateTables_ItemRateTableName = Helpers.createClassArray(ProjectTemplateRateTable, item.ProjectTemplateRateTables_ItemRateTableName);
      this.Employee = new Employee(item.Employee);
    }
  }
}